import Tooltip from '@jetbrains/ring-ui-built/components/tooltip/tooltip'
import type {ReactNode} from 'react'

import styles from './DisabledButtonHint.module.css'

export {styles as disabledButtonHintStyles}

type Props = {
  disabled: boolean | null | undefined
  reason: string | null | undefined
  children: ReactNode
}

export default function DisabledButtonHint({disabled, reason, children}: Props) {
  if (disabled && reason) {
    return (
      <Tooltip title={reason} popupProps={{className: styles.tooltipPopup}}>
        <span className={styles.disabled}>{children}</span>
      </Tooltip>
    )
  }

  return <>{children}</>
}
